module.exports = __webpack_public_path__ + "img/logo-orkanet.38830733.png";